<template>
  <div class="section-page">
    <Transition name="fade-page">
      <div v-if="isShowNavSubsections" id="nav-wrap" class="container section-page__nav-wrap">
        <NavSubsections>
          <template #actions>
            <FilterButton v-if="isShowFilterButton" />
          </template>
        </NavSubsections>
      </div>
    </Transition>

    <div class="section-page__content">
      <Transition name="fade-page">
        <ViewMode v-if="isShowSectionViewLayout" />

        <NuxtChild v-else :key="keyChangeContent" />
      </Transition>
    </div>

    <FilterList />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavSubsections from '~/components/Lobby/NavSubsections'
import ViewMode from '~/components/Lobby/ViewMode'
import { ENUM_CATEGORY, VIEW_MODE, PARAM_SUB_PAGE } from '@/components/Lobby/enum.js'
import FilterList from '~/components/Lobby/FilterList'
import FilterButton from '~/components/Lobby/FilterButton'

let isLivePage
const INITIAL_DELAY_FOR_PRAGMATIC_LIVE_WS_MS = 2000

export default {
  name: 'SectionPage',
  components: {
    NavSubsections,
    ViewMode,
    FilterList,
    FilterButton,
  },
  computed: {
    ...mapGetters('lobby', [
      'get_sectionList',
      'get_currentSection',
    ]),
    isShowSectionViewLayout() {
      return Object.keys(this.$route.params).length === 1
    },
    keyChangeContent() {
      return this.$route.path
    },
    isShowNavSubsections() {
      return (this.currentSection?.viewMode === VIEW_MODE.DEFAULT)
        || Object.keys(this.$route.params).length === 1
    },
    currentSection() {
      return this.get_currentSection(this.$route)
    },
    isLivePage() {
      return this.currentSection?.term === ENUM_CATEGORY.LIVE.NAME
    },
    isShowFilterButton() {
      return this.$route.params[PARAM_SUB_PAGE]
    },
  },
  mounted() {
    setTimeout(() => {
      this.initPragmaticLive()
    }, INITIAL_DELAY_FOR_PRAGMATIC_LIVE_WS_MS)
  },
  beforeDestroy() {
    this.disconnectPragmaticLive()
  },
  methods: {
    initPragmaticLive() {
      if (!this.isLivePage) return
      isLivePage = this.isLivePage
      this.$pragmaticLive.init()
    },
    disconnectPragmaticLive() {
      if (!isLivePage) return
      this.$pragmaticLive.disconnect()
    },
  },
}
</script>

<style lang="scss" scoped>
  .section-page {
    &__content {
      padding-top: var(--spaces-l);
      overflow: hidden;

      @include media(tablet) {
        padding-top: var(--padding-3xl);
      }

      @include media(landscape) {
        padding-top: var(--spaces-l);
      }
    }
  }
</style>
